import { useMemo } from "react";
import { useInscriptionStatus } from "@/hooks/useInscriptionStatus";
import { usePdcExternalCoursesQuery } from "@/hooks/usePdcExternalCoursesQuery";
import { InscriptionStatus } from "@/services/inscription/types";
import { isMergedRegistrationComplete } from "@/utils/inscriptionPdcMerge";
import { isPdcExternalCourseListEnabled } from "@/utils/pdc-external-course-list";

export function useRegistrationCompletion() {
  const { data: inscription, isLoading } = useInscriptionStatus();
  const usePdcList = isPdcExternalCourseListEnabled();
  const { data: pdcCourses, isError: pdcCoursesError } = usePdcExternalCoursesQuery({
    enabled: usePdcList,
  });

  const isRegistrationComplete = useMemo(() => {
    if (!inscription) return false;
    if (usePdcList && pdcCoursesError) {
      return inscription.status === InscriptionStatus.COMPLETED;
    }
    return isMergedRegistrationComplete(inscription, pdcCourses, usePdcList);
  }, [inscription, pdcCourses, usePdcList, pdcCoursesError]);

  return { isRegistrationComplete, isLoadingRegistration: isLoading };
}
